import React from 'react';
import ReactDOM from 'react-dom';
import RealTimeLectureList from '../components/real-time-lecture/real-time-lecture-list/RealTimeLectureList';
import { initializeI18n } from '../localization/i18n';
import PrimeReact from 'primereact/api';
// Expose render function globally
window.renderRealTimeLectureList = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<RealTimeLectureList props={props} />, element);
            })
            .catch(error => {
                //console.error("Failed to initialize i18n before rendering RealTimeLectureList:", error);
            });

    } else {
        //console.error(`Element with ID ${elementId} not found.`);
    }
};
